import { populate } from 'populate';import dragonBones from 'pixi-dragonbones';

const raw = {
  className: 'HalloweenPlinkoMinigameLayout',
  width: 1350,
  height: 760,
  x: 0,
  y: 0,
  list: [
    {
      id: '5a8da466-ad6e-4dad-b65b-ba33e892e568',
      type: 'Container',
      name: 'root',
      nameSpace: '',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '',
      data: ''
    },
    {
      id: 'f6315d43-b7da-4c5c-82f5-ded400e1386c',
      type: 'Sprite',
      name: 'plinkoBg',
      nameSpace: '',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Plinko_BG',
      parent: '5a8da466-ad6e-4dad-b65b-ba33e892e568',
      data: ''
    },
    {
      id: 'fb3059ff-fba0-4189-ac40-432b750af90e',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1119,
      y: 62,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'UI_halloween_intro_Bat_2',
      parent: '5a8da466-ad6e-4dad-b65b-ba33e892e568',
      data: ''
    },
    {
      id: 'c9b8867f-2bc7-43a6-906a-2b6ea8f9dcb4',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 217,
      y: 4,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'UI_halloween_intro_Bat',
      parent: '5a8da466-ad6e-4dad-b65b-ba33e892e568',
      data: ''
    },
    {
      id: '7a442d1c-9e95-480d-ac25-961b9513792d',
      type: 'Sprite',
      name: 'plinkoBoard',
      nameSpace: '',
      className: '',
      x: 801,
      y: 375,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Plinko_window',
      parent: 'f6315d43-b7da-4c5c-82f5-ded400e1386c',
      data: ''
    },
    {
      id: '330efbd0-77b3-41dc-8118-a283fa41725d',
      type: 'Sprite',
      name: 'closeButton',
      nameSpace: '',
      className: '',
      x: 1301,
      y: 49,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: 'None'
      },
      texture: 'btn_close',
      parent: 'f6315d43-b7da-4c5c-82f5-ded400e1386c',
      data: ''
    },
    {
      id: 'd753e677-8a68-4c43-8919-3b71302fa5c4',
      type: 'Sprite',
      name: 'charSprite',
      nameSpace: '',
      className: '',
      x: 190,
      y: 453,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Halloween_Girl_PRELEVEL',
      parent: 'f6315d43-b7da-4c5c-82f5-ded400e1386c',
      data: ''
    },
    {
      id: '881e1083-2943-4c8f-b7aa-65875cc4c603',
      type: 'Container',
      name: 'coinBarContainer',
      nameSpace: '',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'f6315d43-b7da-4c5c-82f5-ded400e1386c',
      data: ''
    },
    {
      id: '0b3a7e64-4666-4096-a711-c726144815b1',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 0,
      y: -340,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Plinko_tittle',
      parent: '7a442d1c-9e95-480d-ac25-961b9513792d',
      data: ''
    },
    {
      id: '0280c6b1-1ad3-40fe-b0d7-643cf1857ac6',
      type: 'Armature',
      name: 'dropperArmature',
      nameSpace: '',
      className: '',
      x: 0,
      y: -305,
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      parent: '7a442d1c-9e95-480d-ac25-961b9513792d',
      data: '',
      animationName: 'idle',
      armatureName: 'dropper',
      dragonbonesName: 'plinko_UI_animations',
      playOnStart: true,
      progress: 0,
      playTimes: 0
    },
    {
      id: '89327e34-3a67-47ab-9281-258a3ab89ac6',
      type: 'Armature',
      name: 'shadowArmature',
      nameSpace: '',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 0,
      visible: true,
      interactive: false,
      buttonMode: false,
      parent: '7a442d1c-9e95-480d-ac25-961b9513792d',
      data: '',
      animationName: 'animation',
      armatureName: 'board_shadow',
      dragonbonesName: 'plinko_UI_animations',
      playOnStart: false,
      progress: 0,
      playTimes: 1
    },
    {
      id: 'b9c0fc06-8e7d-47ea-9f5f-5fac2fb2c9e5',
      type: 'Container',
      name: 'tokenContainer',
      nameSpace: '',
      className: '',
      x: 0,
      y: -243,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '7a442d1c-9e95-480d-ac25-961b9513792d',
      data: ''
    },
    {
      id: 'a5d567e2-f269-46ba-8f4d-2e52d539fd26',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: -388,
      y: 225,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Plinko_Shelf',
      parent: '7a442d1c-9e95-480d-ac25-961b9513792d',
      data: ''
    },
    {
      id: '3d583328-b02d-4861-b332-b407609c384e',
      type: 'Armature',
      name: 'rewardArmature',
      nameSpace: '',
      className: '',
      x: 0,
      y: 135,
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 0,
      visible: true,
      interactive: false,
      buttonMode: false,
      parent: '7a442d1c-9e95-480d-ac25-961b9513792d',
      data: '',
      animationName: 'animation',
      armatureName: 'reward_regular',
      dragonbonesName: 'plinko_UI_animations',
      playOnStart: false,
      progress: 0,
      playTimes: 1
    },
    {
      id: '08794fc9-88ff-4d5d-b085-eedc8f8fe102',
      type: 'Armature',
      name: 'jackpotArmature',
      nameSpace: '',
      className: '',
      x: 0,
      y: -12,
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 0,
      visible: true,
      interactive: false,
      buttonMode: false,
      parent: '7a442d1c-9e95-480d-ac25-961b9513792d',
      data: '',
      animationName: 'animation',
      armatureName: 'reward_jackpot',
      dragonbonesName: 'plinko_UI_animations',
      playOnStart: false,
      progress: 0,
      playTimes: 1
    },
    {
      id: '71734976-6625-4d8f-b9d5-f5c010179b9d',
      type: 'Container',
      name: '',
      nameSpace: 'rewardContainer',
      className: '',
      x: 0,
      y: 206,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '7a442d1c-9e95-480d-ac25-961b9513792d',
      data: ''
    },
    {
      id: '08a00398-fe52-4f6d-9fec-9d0b22d6fb46',
      type: 'Sprite',
      name: 'claimButton',
      nameSpace: '',
      className: '',
      x: 0,
      y: 318,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 0,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: 'None'
      },
      texture: 'green_button',
      parent: '7a442d1c-9e95-480d-ac25-961b9513792d',
      data: ''
    },
    {
      id: 'c3d66822-ce10-4edf-98fd-2d470afaac4d',
      type: 'Sprite',
      name: 'buyButton',
      nameSpace: '',
      className: '',
      x: -198,
      y: 318,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: 'None'
      },
      texture: 'green_button',
      parent: '7a442d1c-9e95-480d-ac25-961b9513792d',
      data: ''
    },
    {
      id: '3f22d138-e13c-4b0a-95a7-560c3a86bb46',
      type: 'Sprite',
      name: 'buyExtraButton',
      nameSpace: '',
      className: '',
      x: 198,
      y: 318,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: 'None'
      },
      texture: 'green_button',
      parent: '7a442d1c-9e95-480d-ac25-961b9513792d',
      data: ''
    },
    {
      id: '183c31cc-d1ca-4e8c-abd8-c46f5f13616d',
      type: 'Sprite',
      name: 'dropButton',
      nameSpace: '',
      className: '',
      x: 0,
      y: 318,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: 'None'
      },
      texture: 'green_button',
      parent: '7a442d1c-9e95-480d-ac25-961b9513792d',
      data: ''
    },
    {
      id: '33434f0f-78a6-42db-b246-96a6b48b827f',
      type: 'Sprite',
      name: 'iapInfo',
      nameSpace: '',
      className: '',
      x: 291,
      y: -133,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'ftux_dialog',
      parent: 'd753e677-8a68-4c43-8919-3b71302fa5c4',
      data: ''
    },
    {
      id: 'b0899c04-2b04-40fa-9489-f24bfe4696e6',
      type: 'Text',
      name: 'jackpotValue',
      nameSpace: '',
      className: '',
      x: -310,
      y: 27,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: '100,000',
      localize: false,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 50,
      icons: [],
      style: {
        fontSize: 56,
        fontWeight: 'normal',
        fontFamily: 'ArchivoBlack',
        fill: 'white',
        stroke: '#541800',
        strokeThickness: 8,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: '08794fc9-88ff-4d5d-b085-eedc8f8fe102',
      data: ''
    },
    {
      id: '5ee4d56d-df31-418d-bc15-30d0041c58d6',
      type: 'Container',
      name: 'reward_0',
      nameSpace: 'reward[]',
      className: '',
      x: -322,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '71734976-6625-4d8f-b9d5-f5c010179b9d',
      data: ''
    },
    {
      id: '3dc85be1-c2b5-4f55-91a2-76ade3dbce69',
      type: 'Container',
      name: 'reward_1',
      nameSpace: 'reward[]',
      className: '',
      x: -242,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '71734976-6625-4d8f-b9d5-f5c010179b9d',
      data: ''
    },
    {
      id: '572590c1-f2b7-45c4-8826-a5d689f0b3a6',
      type: 'Container',
      name: 'reward_2',
      nameSpace: 'reward[]',
      className: '',
      x: -162,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '71734976-6625-4d8f-b9d5-f5c010179b9d',
      data: ''
    },
    {
      id: '2e77a5d6-f636-4d78-98c0-731781eedf5d',
      type: 'Container',
      name: 'reward_3',
      nameSpace: 'reward[]',
      className: '',
      x: -82,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '71734976-6625-4d8f-b9d5-f5c010179b9d',
      data: ''
    },
    {
      id: '44982b04-3dbd-41e9-be42-a7cd3aea3c3b',
      type: 'Container',
      name: 'reward_4',
      nameSpace: 'reward[]',
      className: '',
      x: -2,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '71734976-6625-4d8f-b9d5-f5c010179b9d',
      data: ''
    },
    {
      id: 'aadc9a69-0145-4955-abf6-0ed5f111e53d',
      type: 'Container',
      name: 'reward_5',
      nameSpace: 'reward[]',
      className: '',
      x: 82,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '71734976-6625-4d8f-b9d5-f5c010179b9d',
      data: ''
    },
    {
      id: 'a135444b-2d2d-46ba-9330-77bb0de8de29',
      type: 'Container',
      name: 'reward_6',
      nameSpace: 'reward[]',
      className: '',
      x: 162,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '71734976-6625-4d8f-b9d5-f5c010179b9d',
      data: ''
    },
    {
      id: 'b8618a92-1133-48bf-be4f-a019d2ee67d6',
      type: 'Container',
      name: 'reward_7',
      nameSpace: 'reward[]',
      className: '',
      x: 242,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '71734976-6625-4d8f-b9d5-f5c010179b9d',
      data: ''
    },
    {
      id: 'aae3ee1c-8ec7-4c83-8de9-4b76e0ffd8c5',
      type: 'Container',
      name: 'reward_8',
      nameSpace: 'reward[]',
      className: '',
      x: 322,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '71734976-6625-4d8f-b9d5-f5c010179b9d',
      data: ''
    },
    {
      id: 'df098fc2-8bfa-4139-ba3b-12e0fbcfa3ed',
      type: 'Text',
      name: '',
      nameSpace: '',
      className: '',
      x: 0,
      y: -2,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'Claim',
      localize: true,
      maxWidth: 180,
      maxHeight: 58,
      maxFontSize: 35,
      icons: [],
      style: {
        fontSize: 51,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: '#ffffff',
        stroke: '#277617',
        strokeThickness: 6,
        align: 'center',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: '08a00398-fe52-4f6d-9fec-9d0b22d6fb46',
      data: ''
    },
    {
      id: '40913dd4-23c9-4a59-8bab-b732e3ff4113',
      type: 'Text',
      name: 'buyButtonText',
      nameSpace: '',
      className: '',
      x: 0,
      y: -2,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: '',
      localize: false,
      maxWidth: 180,
      maxHeight: 58,
      maxFontSize: 35,
      icons: [],
      style: {
        fontSize: 51,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: '#ffffff',
        stroke: '#277617',
        strokeThickness: 6,
        align: 'center',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: 'c3d66822-ce10-4edf-98fd-2d470afaac4d',
      data: ''
    },
    {
      id: '31118bfb-5619-4328-a3d0-8f26c2fbe5fc',
      type: 'Text',
      name: 'buyExtraButtonText',
      nameSpace: '',
      className: '',
      x: 0,
      y: -2,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: '',
      localize: false,
      maxWidth: 180,
      maxHeight: 58,
      maxFontSize: 35,
      icons: [],
      style: {
        fontSize: 51,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: '#ffffff',
        stroke: '#277617',
        strokeThickness: 6,
        align: 'center',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: '3f22d138-e13c-4b0a-95a7-560c3a86bb46',
      data: ''
    },
    {
      id: '84e3d5ab-e8e2-4077-a0a2-2b4e3f194314',
      type: 'Text',
      name: '',
      nameSpace: '',
      className: '',
      x: 0,
      y: -2,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'Start!',
      localize: true,
      maxWidth: 180,
      maxHeight: 58,
      maxFontSize: 35,
      icons: [],
      style: {
        fontSize: 51,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: '#ffffff',
        stroke: '#277617',
        strokeThickness: 6,
        align: 'center',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: '183c31cc-d1ca-4e8c-abd8-c46f5f13616d',
      data: ''
    },
    {
      id: 'a885e19b-5983-4e79-a7e1-0e7ae079ebcc',
      type: 'Sprite',
      name: 'availableSprite',
      nameSpace: '',
      className: '',
      x: 0,
      y: 43,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'plinko_available_bg',
      parent: '183c31cc-d1ca-4e8c-abd8-c46f5f13616d',
      data: ''
    },
    {
      id: 'a262acc5-638e-4816-8c11-910459d672b7',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: -154,
      y: 15,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: -1,
        y: 1
      },
      angle: 90,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'ftux_dialog_tail',
      parent: '33434f0f-78a6-42db-b246-96a6b48b827f',
      data: ''
    },
    {
      id: 'e5c457d3-d94b-414d-92c8-ac51e856aff0',
      type: 'Text',
      name: '',
      nameSpace: '',
      className: '',
      x: 0,
      y: -2,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'PlinkoIAPInfo',
      localize: true,
      maxWidth: 275,
      maxHeight: 95,
      maxFontSize: 30,
      icons: [],
      style: {
        fontSize: 23,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: '#982513',
        stroke: 'black',
        strokeThickness: 0,
        align: 'center',
        wordWrap: true,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: '33434f0f-78a6-42db-b246-96a6b48b827f',
      data: ''
    },
    {
      id: 'e036df22-faac-441d-a6df-d8facdcbd2ac',
      type: 'Container',
      name: '',
      nameSpace: '',
      className: '',
      x: 128,
      y: 260,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '33434f0f-78a6-42db-b246-96a6b48b827f',
      data: ''
    },
    {
      id: '29e4202d-fdce-4f45-b68e-137766d4b05d',
      type: 'Container',
      name: '',
      nameSpace: '',
      className: '',
      x: 513,
      y: 262,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '33434f0f-78a6-42db-b246-96a6b48b827f',
      data: ''
    },
    {
      id: 'c11c44c3-1929-44f3-b022-46188f595f60',
      type: 'Sprite',
      name: 'rewardSprite',
      nameSpace: '',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'crop_coin',
      parent: '5ee4d56d-df31-418d-bc15-30d0041c58d6',
      data: ''
    },
    {
      id: '56364a97-9bf9-43db-9808-2fc4c0b9901e',
      type: 'Text',
      name: 'rewardText',
      nameSpace: '',
      className: '',
      x: 0,
      y: 31,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: '100,000',
      localize: false,
      maxWidth: 80,
      maxHeight: 32,
      maxFontSize: 30,
      icons: [],
      style: {
        fontSize: 30,
        fontWeight: 'normal',
        fontFamily: 'ArchivoBlack',
        fill: '#FFD7CA',
        stroke: '#662810',
        strokeThickness: 4,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: '5ee4d56d-df31-418d-bc15-30d0041c58d6',
      data: ''
    },
    {
      id: 'bca7fbf1-fc32-4323-b760-b3258009f917',
      type: 'Sprite',
      name: 'rewardSprite',
      nameSpace: '',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'crop_coin',
      parent: '3dc85be1-c2b5-4f55-91a2-76ade3dbce69',
      data: ''
    },
    {
      id: '13faa7e7-fb9a-4452-bf6c-a454ed4846d1',
      type: 'Text',
      name: 'rewardText',
      nameSpace: '',
      className: '',
      x: 0,
      y: 31,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: '100,000',
      localize: false,
      maxWidth: 80,
      maxHeight: 32,
      maxFontSize: 30,
      icons: [],
      style: {
        fontSize: 30,
        fontWeight: 'normal',
        fontFamily: 'ArchivoBlack',
        fill: '#FFD7CA',
        stroke: '#662810',
        strokeThickness: 4,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: '3dc85be1-c2b5-4f55-91a2-76ade3dbce69',
      data: ''
    },
    {
      id: '15024408-c5a6-472a-bf95-d47be29c175e',
      type: 'Sprite',
      name: 'rewardSprite',
      nameSpace: '',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'crop_coin',
      parent: '572590c1-f2b7-45c4-8826-a5d689f0b3a6',
      data: ''
    },
    {
      id: '05c260fc-8320-431b-876b-d7a33b53d1ef',
      type: 'Text',
      name: 'rewardText',
      nameSpace: '',
      className: '',
      x: 0,
      y: 31,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: '100,000',
      localize: false,
      maxWidth: 80,
      maxHeight: 32,
      maxFontSize: 30,
      icons: [],
      style: {
        fontSize: 30,
        fontWeight: 'normal',
        fontFamily: 'ArchivoBlack',
        fill: '#FFD7CA',
        stroke: '#662810',
        strokeThickness: 4,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: '572590c1-f2b7-45c4-8826-a5d689f0b3a6',
      data: ''
    },
    {
      id: '1e5772e6-a1d0-4dc0-953f-aa55547c6203',
      type: 'Sprite',
      name: 'rewardSprite',
      nameSpace: '',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'crop_coin',
      parent: '2e77a5d6-f636-4d78-98c0-731781eedf5d',
      data: ''
    },
    {
      id: 'e758d54c-99bc-43fe-97dc-3be3ad01343c',
      type: 'Text',
      name: 'rewardText',
      nameSpace: '',
      className: '',
      x: 0,
      y: 31,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: '100,000',
      localize: false,
      maxWidth: 80,
      maxHeight: 32,
      maxFontSize: 30,
      icons: [],
      style: {
        fontSize: 30,
        fontWeight: 'normal',
        fontFamily: 'ArchivoBlack',
        fill: '#FFD7CA',
        stroke: '#662810',
        strokeThickness: 4,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: '2e77a5d6-f636-4d78-98c0-731781eedf5d',
      data: ''
    },
    {
      id: 'bfb6a32a-314e-4431-b524-26ef651da11e',
      type: 'Sprite',
      name: 'rewardSprite',
      nameSpace: '',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'crop_coin',
      parent: '44982b04-3dbd-41e9-be42-a7cd3aea3c3b',
      data: ''
    },
    {
      id: '347e75c3-9316-4640-b1d5-be2161b0c175',
      type: 'Text',
      name: 'rewardText',
      nameSpace: '',
      className: '',
      x: 0,
      y: 31,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: '100,000',
      localize: false,
      maxWidth: 80,
      maxHeight: 32,
      maxFontSize: 30,
      icons: [],
      style: {
        fontSize: 30,
        fontWeight: 'normal',
        fontFamily: 'ArchivoBlack',
        fill: '#FFD7CA',
        stroke: '#662810',
        strokeThickness: 4,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: '44982b04-3dbd-41e9-be42-a7cd3aea3c3b',
      data: ''
    },
    {
      id: 'bce0f951-ff6c-421e-9585-8413e55b62ee',
      type: 'Sprite',
      name: 'rewardSprite',
      nameSpace: '',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'crop_coin',
      parent: 'aadc9a69-0145-4955-abf6-0ed5f111e53d',
      data: ''
    },
    {
      id: '87b2f0a3-8171-4c9b-999a-5923a5fe2ed5',
      type: 'Text',
      name: 'rewardText',
      nameSpace: '',
      className: '',
      x: 0,
      y: 31,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: '100,000',
      localize: false,
      maxWidth: 80,
      maxHeight: 32,
      maxFontSize: 30,
      icons: [],
      style: {
        fontSize: 30,
        fontWeight: 'normal',
        fontFamily: 'ArchivoBlack',
        fill: '#FFD7CA',
        stroke: '#662810',
        strokeThickness: 4,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: 'aadc9a69-0145-4955-abf6-0ed5f111e53d',
      data: ''
    },
    {
      id: '0fbb5070-30d9-4321-990e-679b828e17df',
      type: 'Sprite',
      name: 'rewardSprite',
      nameSpace: '',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'crop_coin',
      parent: 'a135444b-2d2d-46ba-9330-77bb0de8de29',
      data: ''
    },
    {
      id: '5af47604-1378-4bfb-a1e9-ba5b2dbb3fad',
      type: 'Text',
      name: 'rewardText',
      nameSpace: '',
      className: '',
      x: 0,
      y: 31,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: '100,000',
      localize: false,
      maxWidth: 80,
      maxHeight: 32,
      maxFontSize: 30,
      icons: [],
      style: {
        fontSize: 30,
        fontWeight: 'normal',
        fontFamily: 'ArchivoBlack',
        fill: '#FFD7CA',
        stroke: '#662810',
        strokeThickness: 4,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: 'a135444b-2d2d-46ba-9330-77bb0de8de29',
      data: ''
    },
    {
      id: '4640afc8-25f6-45f8-b9b8-1e86b70f2d77',
      type: 'Sprite',
      name: 'rewardSprite',
      nameSpace: '',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'crop_coin',
      parent: 'b8618a92-1133-48bf-be4f-a019d2ee67d6',
      data: ''
    },
    {
      id: '4d21e87e-762a-4d02-aad2-4f5338ffaff0',
      type: 'Text',
      name: 'rewardText',
      nameSpace: '',
      className: '',
      x: 0,
      y: 31,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: '100,000',
      localize: false,
      maxWidth: 80,
      maxHeight: 32,
      maxFontSize: 30,
      icons: [],
      style: {
        fontSize: 30,
        fontWeight: 'normal',
        fontFamily: 'ArchivoBlack',
        fill: '#FFD7CA',
        stroke: '#662810',
        strokeThickness: 4,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: 'b8618a92-1133-48bf-be4f-a019d2ee67d6',
      data: ''
    },
    {
      id: '2cec2ece-201d-43db-bf03-83f3ca59acb9',
      type: 'Sprite',
      name: 'rewardSprite',
      nameSpace: '',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'crop_coin',
      parent: 'aae3ee1c-8ec7-4c83-8de9-4b76e0ffd8c5',
      data: ''
    },
    {
      id: '25f4a09a-b93b-4ed3-b0c8-ccc57f4994c9',
      type: 'Text',
      name: 'rewardText',
      nameSpace: '',
      className: '',
      x: 0,
      y: 31,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: '100,000',
      localize: false,
      maxWidth: 80,
      maxHeight: 32,
      maxFontSize: 30,
      icons: [],
      style: {
        fontSize: 30,
        fontWeight: 'normal',
        fontFamily: 'ArchivoBlack',
        fill: '#FFD7CA',
        stroke: '#662810',
        strokeThickness: 4,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: 'aae3ee1c-8ec7-4c83-8de9-4b76e0ffd8c5',
      data: ''
    },
    {
      id: '7a644ede-2dd1-49cc-91d3-4c411425f472',
      type: 'Text',
      name: 'dropTokenLeftText',
      nameSpace: '',
      className: '',
      x: 0,
      y: -1,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'xPlinkoTokenLeft',
      localize: true,
      maxWidth: 143,
      maxHeight: 29,
      maxFontSize: 25,
      icons: [],
      style: {
        fontSize: 20,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: 'white',
        stroke: 'white',
        strokeThickness: 0,
        align: 'center',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 1,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 8,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: 'a885e19b-5983-4e79-a7e1-0e7ae079ebcc',
      data: ''
    },
    {
      id: 'a70f3e12-b835-42a8-b7fd-fc09e2c838e6',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 26,
      y: 4,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Plinko_token',
      parent: 'e036df22-faac-441d-a6df-d8facdcbd2ac',
      data: ''
    },
    {
      id: '2a6da280-2867-4d7f-a597-16e31c05804c',
      type: 'Text',
      name: '',
      nameSpace: '',
      className: '',
      x: -35,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: '+3',
      localize: false,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 51,
        fontWeight: 'normal',
        fontFamily: 'RobotoBlack',
        fill: '#ffffff',
        stroke: '#7a0369',
        strokeThickness: 6,
        align: 'center',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: 'e036df22-faac-441d-a6df-d8facdcbd2ac',
      data: ''
    },
    {
      id: '7f0504b8-4a3e-4b96-b4cf-a5724fbc34e4',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 40,
      y: 4,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Plinko_token',
      parent: '29e4202d-fdce-4f45-b68e-137766d4b05d',
      data: ''
    },
    {
      id: 'c3693328-5862-40a1-863e-26fb866934a4',
      type: 'Text',
      name: '',
      nameSpace: '',
      className: '',
      x: -35,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: '+10',
      localize: false,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 51,
        fontWeight: 'normal',
        fontFamily: 'RobotoBlack',
        fill: '#ffffff',
        stroke: '#7a0369',
        strokeThickness: 6,
        align: 'center',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: '29e4202d-fdce-4f45-b68e-137766d4b05d',
      data: ''
    }
  ],
  version: '1.0.x'
} as const;

export class HalloweenPlinkoMinigameLayout {
  static raw = raw;
  root: PIXI.Container
  plinkoBg: PIXI.Sprite
  plinkoBoard: PIXI.Sprite
  dropperArmature: dragonBones.PixiArmatureDisplay
  shadowArmature: dragonBones.PixiArmatureDisplay
  tokenContainer: PIXI.Container
  rewardArmature: dragonBones.PixiArmatureDisplay
  jackpotArmature: dragonBones.PixiArmatureDisplay
  jackpotValue: PIXI.Text
  claimButton: PIXI.Sprite
  buyButton: PIXI.Sprite
  buyButtonText: PIXI.Text
  buyExtraButton: PIXI.Sprite
  buyExtraButtonText: PIXI.Text
  dropButton: PIXI.Sprite
  availableSprite: PIXI.Sprite
  dropTokenLeftText: PIXI.Text
  closeButton: PIXI.Sprite
  charSprite: PIXI.Sprite
  iapInfo: PIXI.Sprite
  coinBarContainer: PIXI.Container
  rewardContainer: {
    reward_0: PIXI.Container
    reward_1: PIXI.Container
    reward_2: PIXI.Container
    reward_3: PIXI.Container
    reward_4: PIXI.Container
    reward_5: PIXI.Container
    reward_6: PIXI.Container
    reward_7: PIXI.Container
    reward_8: PIXI.Container
    reward: ({
      rewardSprite: PIXI.Sprite
      rewardText: PIXI.Text
      children: (PIXI.Sprite | PIXI.Text)[]
    })[]
    children: (PIXI.Container)[]
  }

  constructor() {
    populate(this, raw);
  }
}
